export var AnimationTimings;
(function (AnimationTimings) {
    AnimationTimings["productive"] = "cubic-bezier(0.000, 0.000, 0.440, 0.960)";
    AnimationTimings["expressive"] = "cubic-bezier(0.645, 0.045, 0.355, 1.000)";
    AnimationTimings["entranceProductive"] = "cubic-bezier(0.000, 0.000, 0.270, 0.960)";
    AnimationTimings["entranceExpressive"] = "cubic-bezier(0.050, 0.025, 0.260, 0.960)";
    AnimationTimings["exitProductive"] = "cubic-bezier(0.200, 0.000, 1.000, 0.850)";
    AnimationTimings["exitExpressive"] = "cubic-bezier(0.100, 0.015, 0.850, 0.100)";
    AnimationTimings["linear"] = "linear";
})(AnimationTimings || (AnimationTimings = {}));
const DefaultConfig = {
    duration: '0.2s',
    timing: AnimationTimings.linear,
    delay: '0s',
    iterations: 'infinite',
    direction: 'normal',
    fill: 'none',
};
export const createAnimation = (animationConfig) => {
    const { name, duration, timing, delay, iterations, direction, fill } = { ...DefaultConfig, ...animationConfig };
    return `animation: ${name} ${duration} ${timing} ${delay} ${iterations} ${direction} ${fill};`;
};
//# sourceMappingURL=Animation.js.map